import { render, staticRenderFns } from "./Cna.vue?vue&type=template&id=99ec5ea0&scoped=true&lang=html&"
import script from "./Cna.vue?vue&type=script&lang=js&"
export * from "./Cna.vue?vue&type=script&lang=js&"
import style0 from "./Cna.vue?vue&type=style&index=0&id=99ec5ea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ec5ea0",
  null
  
)

export default component.exports